import Button, { ButtonWrap } from '@hubins/components/Button';
import CountriesDropdown from '@hubins/components/CountriesDropdown/CountriesDropdown';
import Input from '@hubins/components/Input';
import Modal from '@hubins/components/Modal';
import { useMiddleman } from '@hubins/middleman';
import { Column, Columns } from 'components/Columns';
import ErrorMessage from 'components/ErrorMessage';
import __ from 'localisation';
import React, { useEffect, useState } from 'react';

const Country = ({ country, handleChange, index, removeCountry }) => {
  const [countryCode, setCountryCode] = useState(country.country);
  const [tin, setTin] = useState(country.tin);

  useEffect(() => {
    handleChange(index, { country: countryCode, tin });
  }, [countryCode, tin]);

  return (
    <>
      <Column s="1" className="flex-center">
        <Button
          icon="Bin by Streamlinehq"
          className="danger s-top-m"
          iconColor="white"
          onClick={() => removeCountry(index)}
          onlyIcon
        />
      </Column>
      <Column s="5">
        <CountriesDropdown
          placeholder={__('select_country')}
          label={__('country')}
          value={countryCode}
          callback={setCountryCode}
        />
      </Column>
      <Column s="6">
        <Input
          placeholder={__('tin_number')}
          label={__('tin_number')}
          value={tin}
          callback={setTin}
        />
      </Column>
      <Column s="12">
        <hr />
      </Column>
    </>
  );
};

const EditTaxDomiciles = ({ profileUuid, countries: propsCountries, setOpenModal, refetch }) => {
  const [countries, setCountries] = useState(propsCountries);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const middleman = useMiddleman();

  const handleChange = (index: number, country: any) => {
    setCountries((prevCountries) => {
      const newCountries = [...prevCountries];
      newCountries[index] = country;
      return newCountries;
    });
  };

  const addCountry = () => {
    setCountries((prevCountries) => {
      const newCountries = [...prevCountries];
      newCountries.push({ country: '', tin: '' });
      return newCountries;
    });
  };

  const save = async () => {
    setLoading(true);
    try {
      setError(null);
      await middleman.post(`/ql/crm/tax-domiciles/${profileUuid}`, {
        countries,
      });
      refetch();
      setOpenModal(false);
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  const removeCountry = (index: number) => {
    setCountries((prevCountries) => {
      const newCountries = [...prevCountries];
      newCountries.splice(index, 1);
      return newCountries;
    });
  };

  return (
    <Modal open={true} callback={setOpenModal} shouldCloseOnOverlayClick closeButton>
      <Columns className="s-top-m">
        {countries.map((country, index) => (
          <Country
            key={`country_${index}`}
            country={country}
            handleChange={handleChange}
            index={index}
            removeCountry={removeCountry}
          />
        ))}
        <Column s="12">
          <Button icon="add" onClick={addCountry}>
            {__('add_country')}
          </Button>
        </Column>
        <Column s="12" className="s-top-xl">
          <ButtonWrap>
            <Button
              icon="pencil write 2"
              className="cta"
              iconColor="white"
              onClick={save}
              disabled={loading}
              loading={loading}
            >
              {__('save')}
            </Button>
            <Button icon="remove" onClick={() => setOpenModal(false)} disabled={loading}>
              {__('close')}
            </Button>
          </ButtonWrap>
          <ErrorMessage text={error} showError={!!error} />
        </Column>
      </Columns>
    </Modal>
  );
};

export default EditTaxDomiciles;
